import { render, staticRenderFns } from "./Controllers.vue?vue&type=template&id=586c31c6&"
import script from "./Controllers.vue?vue&type=script&lang=js&"
export * from "./Controllers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports